module.exports = __webpack_public_path__ + "img/ic_process_no5.4dd39da0.png";